import SellingGuideCard from './selling-guide-card';

export default SellingGuideCard;
